// Contributeurs de ZERO KAMI, affichés dans la fenêtre « À propos » (ui/aboutDialog.js). L'accord de licence exclusive
// (art. 6.2) impose de créditer chaque Contributor sous le nom ou le pseudonyme de son choix, avec son rôle, et de tenir
// la liste à jour : à chaque arrivée, ajouter une ligne ici.
//   name : nom ou pseudonyme choisi par la personne
//   role : { fr, en } facultatif ; sans rôle, seul le nom est affiché
export const CONTRIBUTORS = Object.freeze([
  { name: 'Christophe NEY' },
  { name: 'Mathieu NEY' },
  { name: 'Glen CARL' },
]);
